<template>

    <v-page-section>
        <template #title>Change Password</template>
        <template #body>
            <v-form-group label="New Password" caption="A new password for your account.">
                <v-input class="w-500" type="password" :model="params.password" @input="params.password = $event" />
            </v-form-group>
            <v-form-group label="Confirm New Password" caption="Enter the new password again.">
                <v-input class="w-500" type="password" :model="params.password_confirmation" @input="params.password_confirmation = $event" />
            </v-form-group>
        </template>
        <template #footer>
            <v-button size="sm" :loading="loading" @click.native="submit">Save</v-button>
        </template>
    </v-page-section>

</template>

<script>

import UserApi from '@api/UserApi';

export default {

    data() {
        return {
            loading: false,
            params: {},
        }
    },

    methods: {

        submit() {
            this.loading = true;
            UserApi.updatePassword(this.params)
                .then((response) => {
                    this.loading = false;
                    this.$store.commit('setAlertSuccess', this.$t('message.saved'));
                }, (error) => {
                    this.loading = false;
                    this.$store.commit('setAlertWithError', error);
                });
        },

    },

}

</script>
